import { render } from "./ProfileRawMatSpecificactionComponent.vue?vue&type=template&id=f9bc656a&scoped=true"
import script from "./ProfileRawMatSpecificactionComponent.vue?vue&type=script&lang=js"
export * from "./ProfileRawMatSpecificactionComponent.vue?vue&type=script&lang=js"

import "./ProfileRawMatSpecificactionComponent.vue?vue&type=style&index=0&id=f9bc656a&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bc656a"]])

export default __exports__